// DO NOT EDIT THIS FILE!
// This file was generated by ubi-generators (https://ghe.spotify.net/datainfra/ubi-generators).
// For support, contact us on the #ubi-users Slack channel.
const SPECIFICATION_ID = "web-support-header";
const APP = "support-spotify-com";
const SPECIFICATION_VERSION = "1.0.0";
const SPECIFICATION_MODE = "default";
const GENERATOR_VERSION = "15.0.0";
const Identifier = {
    ARTISTS: "artists",
    CONSUMER: "consumer",
    FINDAWAYVOICES: "findawayvoices",
    PODCASTERS: "podcasters",
};
/**
 * Creates an event factory to generate events
 * @params options - The required context for this specification
 *  - `option.data`: Required metadata for root parameters
 *  - {artists|consumer|findawayvoices|podcasters} `option.data.identifier`: The support site vertical
 * @returns {WebSupportHeaderEventFactory} A new instance of WebSupportHeaderEventFactory
 */
export function createWebSupportHeaderEventFactory(options) {
    return new WebSupportHeaderEventFactory(options);
}
/**
 * The turnkey header is a shared header component for some verticals on support site.
 */
export class WebSupportHeaderEventFactory {
    constructor(options) {
        this._path = [{
                name: SPECIFICATION_ID,
                ...options.data
            }];
        if (options?.parentAbsoluteLocation) {
            this._parentAbsoluteLocation = options.parentAbsoluteLocation;
        }
    }
    /**
     * Creates a new instance of HeaderContainerEventFactory
     * @returns {HeaderContainerEventFactory}  A new instance of HeaderContainerEventFactory
     */
    headerContainerFactory() {
        return new WebSupportHeaderEventFactory.HeaderContainerEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    _getCurrentLocation() {
        return {
            pathNodes: this._path,
            specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
            specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
        };
    }
    getAbsoluteLocation() {
        const parentLocations = this._parentAbsoluteLocation?.locations;
        return {
            locations: [
                ...(parentLocations || []),
                this._getCurrentLocation()
            ],
        };
    }
}
(function (WebSupportHeaderEventFactory) {
    /**
     * Create HeaderContainerEventFactory class with path
     * @param path to this node
     */
    class HeaderContainerEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "header_container"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
         * Creates a new instance of HeaderAvatarEventFactory
         * @returns {HeaderAvatarEventFactory}  A new instance of HeaderAvatarEventFactory
         */
        headerAvatarFactory() {
            return new WebSupportHeaderEventFactory.HeaderContainerEventFactory.HeaderAvatarEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation
            });
        }
        /**
         * Creates a new instance of HeaderProfileLinksContainerEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- The id of the popover containing the profile links.
         * @returns {HeaderProfileLinksContainerEventFactory}  A new instance of HeaderProfileLinksContainerEventFactory
         */
        headerProfileLinksContainerFactory(data) {
            return new WebSupportHeaderEventFactory.HeaderContainerEventFactory.HeaderProfileLinksContainerEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
    }
    WebSupportHeaderEventFactory.HeaderContainerEventFactory = HeaderContainerEventFactory;
})(WebSupportHeaderEventFactory || (WebSupportHeaderEventFactory = {}));
(function (WebSupportHeaderEventFactory) {
    var HeaderContainerEventFactory;
    (function (HeaderContainerEventFactory) {
        /**
         * Create HeaderAvatarEventFactory class with path
         * @param path to this node
         */
        class HeaderAvatarEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    name: "header_avatar"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_reveal action.
             */
            hitUiReveal() {
                const data = {
                    actionName: "ui_reveal",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create interaction for hit ui_hide action.
             */
            hitUiHide() {
                const data = {
                    actionName: "ui_hide",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        HeaderContainerEventFactory.HeaderAvatarEventFactory = HeaderAvatarEventFactory;
    })(HeaderContainerEventFactory = WebSupportHeaderEventFactory.HeaderContainerEventFactory || (WebSupportHeaderEventFactory.HeaderContainerEventFactory = {}));
})(WebSupportHeaderEventFactory || (WebSupportHeaderEventFactory = {}));
(function (WebSupportHeaderEventFactory) {
    var HeaderContainerEventFactory;
    (function (HeaderContainerEventFactory) {
        /**
         * Create HeaderProfileLinksContainerEventFactory class with path
         * @param path to this node
         */
        class HeaderProfileLinksContainerEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "header_profile_links_container"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            /**
             * Creates a new instance of HeaderProfileLinkEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.identifier- The title of the navigation item
             * @param {string} data.uri- The URI of the navigation item
             * @returns {HeaderProfileLinkEventFactory}  A new instance of HeaderProfileLinkEventFactory
             */
            headerProfileLinkFactory(data) {
                return new WebSupportHeaderEventFactory.HeaderContainerEventFactory.HeaderProfileLinksContainerEventFactory.HeaderProfileLinkEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create impression for HeaderProfileLinksContainerEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        HeaderContainerEventFactory.HeaderProfileLinksContainerEventFactory = HeaderProfileLinksContainerEventFactory;
    })(HeaderContainerEventFactory = WebSupportHeaderEventFactory.HeaderContainerEventFactory || (WebSupportHeaderEventFactory.HeaderContainerEventFactory = {}));
})(WebSupportHeaderEventFactory || (WebSupportHeaderEventFactory = {}));
(function (WebSupportHeaderEventFactory) {
    var HeaderContainerEventFactory;
    (function (HeaderContainerEventFactory) {
        var HeaderProfileLinksContainerEventFactory;
        (function (HeaderProfileLinksContainerEventFactory) {
            /**
             * Create HeaderProfileLinkEventFactory class with path
             * @param path to this node
             */
            class HeaderProfileLinkEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "header_profile_link"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_navigate action.
               * @param destination the destination field
                 */
                hitUiNavigate({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "ui_navigate",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for HeaderProfileLinkEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            HeaderProfileLinksContainerEventFactory.HeaderProfileLinkEventFactory = HeaderProfileLinkEventFactory;
        })(HeaderProfileLinksContainerEventFactory = HeaderContainerEventFactory.HeaderProfileLinksContainerEventFactory || (HeaderContainerEventFactory.HeaderProfileLinksContainerEventFactory = {}));
    })(HeaderContainerEventFactory = WebSupportHeaderEventFactory.HeaderContainerEventFactory || (WebSupportHeaderEventFactory.HeaderContainerEventFactory = {}));
})(WebSupportHeaderEventFactory || (WebSupportHeaderEventFactory = {}));
